<template lang="pug">
//- 单banner纯图片模式
.single-image-banner(
  v-if="isSingleImage"
  v-platform-expose="handleModuleExpose"
  @click="handleBtnClick"
)
  img.single-image-banner-img(
    :src="info.activityBg"
    alt=""
  )
//- 老banner 自定义渲染模式
.new-customer-reward-container(
  v-else
  v-platform-expose="handleModuleExpose"
  :style="{ backgroundImage: `url(${info.activityBg})` }"
)
  .top-area
    .top-area-title
      HighlightText(
        className="top-area-title-text"
        :text="info.title"
        :highlightStyle="highlightStyle"
        :normalStyle="normalStyle"
      )
    .top-area-count-down(v-if="info.remainingTime")
      CountDown(
        :target-time="info.remainingTime"
        @countDownEnd="handleCountDownEnd"
      )
  .bottom-area
    .right-area
      .right-number-info(
        v-if="info.strategyCode === RAKE_BACK_BANNER_STRATEGY.NEW_ORDER_STRATEGY"
      )
        .right-area-number1 {{ info.price }}
        .right-area-number2 {{ info.rewardAmount }}
    .left-area(@click="handleBtnClick")
      .btn(v-flash="{ boom: true, shineLight: false }")
        span.btn-text {{ info.btnText }}
        .btn-mark(v-if="info.rewardAmount")
          .mark-icon
          .mark-text 返币{{ info.rewardAmount }}
</template>

<script>
import HighlightText from '@/components/highlight-text';
import SPM from '../common/spm';
import CountDown from './count-down';
import {
  RAKE_BACK_BANNER_STRATEGY,
  RAKE_BACK_BANNER_TYPE,
} from '../consts';

export default {
  name: 'NewCustomerReward',
  components: {
    HighlightText,
    CountDown,
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // 新人首单banner策略
      RAKE_BACK_BANNER_STRATEGY,
    };
  },
  computed: {
    isSingleImage() {
      const { bannerType } = this.info || {};
      return bannerType === RAKE_BACK_BANNER_TYPE.SINGLE_IMAGE;
    },
    highlightStyle() {
      return {
        fontSize: '0.13rem',
        color: '#ffedb2',
      };
    },
    normalStyle() {
      return {
        fontSize: '0.13rem',
        color: '#fff',
      };
    },
  },
  methods: {
    // 模块曝光
    handleModuleExpose() {
      const { strategyCode } = this.info || {};

      SPM.moduleExpose({
        moduleId: 'Welfare_newmodule',
        contentId: 'Welfare_newmodule',
        businessInfo: {
          code: strategyCode,
          ...this.info,
        },
      });
    },
    // 倒计时结束
    handleCountDownEnd() {
      this.$emit('countDownEnd');
    },
    // 按钮点击
    handleBtnClick() {
      const { strategyCode } = this.info || {};
      // 投放banner点击埋点
      SPM.clickButton({
        buttonName: 'Welfare_newmodule',
        businessInfo: {
          code: strategyCode,
          ...this.info,
        },
      });
      this.$emit('btnClick');
    },
  },
};
</script>

<style lang="less" scoped>
.single-image-banner {
  width: 100%;

  .single-image-banner-img {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 0.12rem;
  }
}

.new-customer-reward-container {
  width: 3.27rem;
  height: 1.11rem;
  border-radius: 0.18rem;
  margin-bottom: 0.12rem;
  padding: 0 0.1rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;

  .top-area {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.04rem 0 0.03rem;
    height: 0.34rem;

    .top-area-title-text {
      display: flex;
    }
  }

  .bottom-area {
    display: flex;
    justify-content: space-between;
    height: 0.67rem;

    .right-area {
      width: 2.15rem;
      height: 0.67rem;
    }

    .right-number-info {
      position: relative;
      display: flex;
      width: 100%;
      height: 100%;
    }

    .right-area-number1 {
      position: absolute;
      top: 0.09rem;
      left: 0.25rem;
      font-family: DINAlternate-Bold, DINAlternate, sans-serif;
      font-size: 0.22rem;
      color: #ff344c;
    }

    .right-area-number2 {
      display: flex;
      justify-content: center;
      position: absolute;
      top: 0.09rem;
      right: 0;
      width: 0.6888rem;
      font-family: DINAlternate-Bold, DINAlternate, sans-serif;
      font-size: 0.22rem;
      color: #ff344c;
    }

    .left-area {
      flex: 1;
      display: flex;
      align-items: center;
      padding-left: 0.08rem;
      height: 0.67rem;
    }

    .btn {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 0.84rem;
      height: 0.28rem;
      border-radius: 0.16rem;
      background-image:
        linear-gradient(
          180deg,
          #fff -7.14%,
          #ffdcdc 63.32%,
          #fff 100%
        );

      .btn-text {
        font-weight: 600;
        font-size: 0.13rem;
        line-height: normal;
        color: #ff384f;
      }

      .btn-mark {
        position: absolute;
        top: -0.14rem;
        right: 0;
        display: flex;
        align-items: center;
        padding: 0 0.05rem 0 0.01rem;
        height: 0.18rem;
        border-radius: 0.2rem;
        background-image: linear-gradient(90deg, #ffd23e 0%, #ffe48d 100%);
      }

      .mark-icon {
        width: 0.16rem;
        height: 0.16rem;
        background-image: url('https://m.hellobike.com/resource/gallery/866/gq4S2HBP_16x16%EF%BC%883x%EF%BC%89.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }

      .mark-text {
        margin-left: 0.01rem;
        font-weight: 600;
        font-size: 0.1rem;
        line-height: normal;
        color: #785300;
      }
    }
  }
}
</style>
